// Context identity and defaults are deliberately independent of auth effects,
// adapters and UI modules, so primitive links can read permissions without a cycle.
import { createContext, Dispatch } from 'react'
import {
  USE_CASE,
  USER_ROLE,
} from '@trustero/trustero-api-web/lib/account/account_pb'
import type { AuthRecord, AuthAction } from './authContext'

export const empty_authctx: AuthRecord = {
  isAuthenticated: false,
  accessToken: '',
  accountId: '',
  email: '',
  useCase: USE_CASE.SAAS_BUYER, // we want to default to limited access
  role: USER_ROLE.READONLY, // we want to default to limited access
  isAuthLoading: true, // we want to default to loading
  isVendorOnlyAccount: false,
}

export type AuthContextType = {
  authCtx: AuthRecord
  authDispatch: Dispatch<AuthAction>
}

export const AuthContext = createContext<AuthContextType>({
  authCtx: empty_authctx,
  authDispatch: () => null,
})
